import { Skeleton } from '@epilot/concorde-elements'
import type {
  ActionBarControlOptions,
  EpilotControlProps
} from '@epilot/journey-logic-commons'
import classNames from 'classnames'

import classes from './ActionBarControlSkeleton.module.scss'

export const ActionBarControlSkeleton = ({
  uischema
}: Pick<EpilotControlProps, 'uischema'>) => {
  const hasBackButton = Boolean(
    (uischema.options as ActionBarControlOptions)?.goBackButton?.isVisible
  )

  return (
    <div className={classes.root}>
      <div
        className={classNames(classes.container, {
          [classes.justifyContentEnd]: !hasBackButton
        })}
      >
        {hasBackButton && (
          <Skeleton className={classes.back}>
            <span>&larr; Go back</span>
          </Skeleton>
        )}
        <Skeleton className={classes.next}>
          <span>Submit &rarr;</span>
        </Skeleton>
      </div>
    </div>
  )
}
